import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Select } from "@ngxs/store";
import { Observable, Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { AppState } from "src/app/app.state";
import { isDefined } from "src/utils/isDefined/isDefined";

@Component({
	selector: "app-info-dialog",
	templateUrl: "./info-dialog.component.html",
	styleUrls: ["./info-dialog.component.scss"],
	encapsulation: ViewEncapsulation.None,
})
export class InfoDialogComponent implements OnInit, OnDestroy, AfterViewInit {
	hasTCU = false;
	subscription = new Subscription();
	isScrollable = false;

	@ViewChild("dialogContent") dialogContent: ElementRef<HTMLDivElement>;

	@Select(AppState.selectCompanyHasTCU) hasTCU$: Observable<boolean>;

	constructor(public dialogRef: MatDialogRef<InfoDialogComponent>) {}

	ngOnInit() {
		this.subscription.add(
			this.hasTCU$.pipe(filter(isDefined)).subscribe(hasTCU => {
				this.hasTCU = hasTCU;
				this.checkScrollable();
			}),
		);
	}

	ngAfterViewInit() {
		this.checkScrollable();
	}

	checkScrollable() {
		setTimeout(() => {
			if (this.dialogContent?.nativeElement) {
				const el = this.dialogContent.nativeElement;
				// Add a small buffer to handle decimal rounding differences
				this.isScrollable = el.scrollHeight > Math.ceil(el.clientHeight) + 1;
			}
		});
	}

	handleKeydown(event: KeyboardEvent) {
		if (!this.isScrollable || !this.dialogContent?.nativeElement) return;

		const el = this.dialogContent.nativeElement;
		const scrollAmount = 40;

		switch (event.key) {
			case "ArrowDown":
				el.scrollTop += scrollAmount;
				event.preventDefault();
				break;
			case "ArrowUp":
				el.scrollTop -= scrollAmount;
				event.preventDefault();
				break;
			case "PageDown":
				el.scrollTop += el.clientHeight;
				event.preventDefault();
				break;
			case "PageUp":
				el.scrollTop -= el.clientHeight;
				event.preventDefault();
				break;
		}
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	closeDialog() {
		this.dialogRef.close();
	}
}
